import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { useEffect } from "react";
import ErrorBoundary from "./components/ErrorBoundary";
import LandingPage from "./pages/LandingPage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import AdminPage from "./pages/AdminPage";
import LoginPage from "./pages/LoginPage";
import TenderRedReviewPage from "./pages/TenderRedReviewPage";
import PriceDeskPage from "./pages/PriceDeskPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import ConfidentialityPage from "./pages/ConfidentialityPage";
import NotFoundPage from "./pages/NotFoundPage";

// Set initial robots meta based on hostname (runs once on app load)
function initializeRobotsMeta() {
  const hostname = window.location.hostname;
  const isProduction = hostname === "blacklineestimating.com" || hostname === "www.blacklineestimating.com";
  
  let robotsMeta = document.querySelector('meta[name="robots"]');
  if (!robotsMeta) {
    robotsMeta = document.createElement("meta");
    robotsMeta.name = "robots";
    document.head.appendChild(robotsMeta);
  }
  
  // Set default based on environment (pages will override as needed)
  robotsMeta.content = isProduction ? "index, follow" : "noindex, nofollow";
}

// Initialize on script load
if (typeof window !== "undefined") {
  initializeRobotsMeta();
}

// Scroll to top on route change, or to hash if present
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Wait for page to render then scroll to element
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <ErrorBoundary>
      <div className="App font-body">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/tender-red-review" element={<TenderRedReviewPage />} />
            <Route path="/price-desk" element={<PriceDeskPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/confidentiality" element={<ConfidentialityPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </ErrorBoundary>
  );
}

export default App;
